import { Form, Row, Col, Button } from 'react-bootstrap'
//import UploadImage from '../uploadImage/UploadImage'
import React, {useState, useRef, useEffect} from "react";
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function PhotoDetails(props) {

    const S3_BUCKET = process.env.s3Bucket

    const endPoint = process.env.s3EndPoint.replace('https://','');
    const IMAGE_PATH = 'https://'+S3_BUCKET+'.'+endPoint;

    const contact_id = props.contactAccount ? props.contactAccount.contactId : null;

    const {data: account} = request.contacts.swrAccount(contact_id);
    

    const [progress , setProgress] = useState(0);
    const [showUpdate, setShowUpdate] = useState(false);
    const [image, setImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(""); 
    const [showText, setShowText] = useState('block');
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [key, setKey] = useState(0);
    const fileInput = useRef(null);

    const handleFile = (input) => {

        const file = input?.target?.files ? input.target.files[0] : input;

        if (!file) {
            return;
        }

        const fileType = file.type;

        if(fileType == "image/jpeg" || fileType == "image/png"){

            setImage(file);
            setPreviewUrl(URL.createObjectURL(file));
            setShowText('none')
            setShowUpdate(true)
            setError("")

        }else{
            onError("File type is not allowed. Only png and jpg are allowed.")
        }
    }

    const handleDragOver = event => {
        event.preventDefault();
    }

    const handleOndrop = event => {
        event.preventDefault();

        let imageFile = event.dataTransfer.files[0];
        handleFile(imageFile);
    }

    const cancel = () => {
        setPreviewUrl("")
        setShowText('block')
        setShowUpdate(false)
    }

    async function handleUpload(e)  {

        await uploadAvatar(image);
    }

    async function handleRemove(e)  {

        await removePhoto(image);
    }

    const uploadAvatar = async image => {
        if (!contact_id || !image) {
            onError('No contact or image found for upload.')
            return
        }

        const profile = await request.contacts.uploadAvatarFile(contact_id, image)

        if (profile && !profile.err) {
            setProgress(100)
            setShowUpdate(false)
            onSuccess('Successfully uploaded photo');
            return
        }

        onError('Upload failed: ' + JSON.stringify(profile?.err || profile))
    };

    const onSuccess = (message) => 
    {
        setMessage(message)
        setError(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    const onError = (message) => 
        {
            setMessage('');  // Clear success message if any
            setError(message);
            setKey(prevKey => prevKey + 1); // Change key to force re-render
        }

    const removePhoto = async image => {
        const del = confirm('Are you sure?');

        if(del){

            const profile = await request.contacts.uploadAvatar(contact_id, null);

            if (profile && profile.err) {
                onError('Delete failed: ' + JSON.stringify(profile.err))
                return
            }

            setShowText('block');
            setPreviewUrl("")
            setShowUpdate(false)
            setImage(null)
            onSuccess('Successfully deleted photo')
        }
    };

    useEffect(() => {
        const avatar = account && account.contact.profile.image != "" && account.contact.profile.image != null ? IMAGE_PATH+'/'+account.contact.profile.image : '';

        if(avatar){
            setPreviewUrl(avatar)
            setShowText('none');
            setImage(account && account.contact.profile.image != "" && account.contact.profile.image != null ? account.contact.profile.image : '')
        }
    }, [account]);


    return (
        <div className="photoDetails py-5 border-bottom">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={message} errorMessage={error}/>
                    <p><strong>Photo</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextStreet" className="mb-4">
                            <Form.Label column md="3" className="text-md-right">Join the community and upload your profile photo</Form.Label>
                            <Col xl="4" lg="4" md="5" sm="6">
                                <div className="bg-light p-3">

                                    <div 
                                        className="drop_zone" style={{display: ""+showText+""}} 
                                        onDragOver = {handleDragOver}
                                        onDrop = {handleOndrop}
                                        onClick = { () => fileInput.current.click()}
                                    > 
                                        <p className="text-center mt-5">Drop image here <br/> or <br/> Click to upload.</p>

                                        <input 
                                            type="file" 
                                            accept='image/*' 
                                            ref={fileInput} hidden 
                                            onChange={e => handleFile(e)}
                                        />
                                    </div> 

                                    {previewUrl && <img src={previewUrl} width="250" height="250" alt='image' /> }
                                    {progress > 0 && progress < 100 ? <div>Uploading.... {progress}%</div> : ''}
                                    {/*<UploadImage/>*/}
                                </div>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextOther">
                            <Form.Label column md="3"></Form.Label>
                            <Col md="7">
                                {/*previewUrl != "" && showUpdate == false ? <Button className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button> : ''*/}
                                {previewUrl != "" && showUpdate == false ? <Button onClick={(e)=>handleRemove(e)} className="px-5 py-2 mb-2 btn btn-danger rounded-pill"><strong>Remove</strong></Button> : ''}

                                {showUpdate && 
                                    <>
                                        <Button onClick={(e)=>handleUpload(e)} className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill"><strong>Save</strong></Button> 
                                        <Button onClick={cancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
           
            <style jsx>{`
                .photoDetails__user{
                    width:250px;
                    height:250px;
                }

                .drop_zone {
                    display: flex;
                    height: 200px;
                    width: 100%;
                    background: white;
                    background-image: url("/icons/upload.png");
                    background-repeat: no-repeat;
                    background-size: 100px;
                    background-position: center;
                    background-color: #ffffff;
                    cursor: pointer;
                    border: 2px dashed #ccc;
                    border-radius: 6px;
                    margin-bottom: 25px;
                    background-position: center 28px;
                }
                .drop_zone>p {
                    margin: auto;
                }
                .image{
                   width: 250px;
                   height: 250px;
                   border-radius: 4px;
                   display: inline-block;
                }
            `}</style>

        </div>
    )
}

export default PhotoDetails

